import Form from "components/Form";
import FormWrapper from "components/Form/form-wrapper";
import ImageUpload from "components/Form/image-upload";
import Input from "components/Form/input";
import ReactSelect from "components/Form/react-select";
import SaveChangesButton from "components/Form/save-changes-button";
import Loader from "components/shared/loader";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    getIdentityVerification,
    submitIdentityVerification,
} from "store/actions";
import {getAllCountries} from "store/data/actions";

export default function IdentityVerification() {
    const {countries, loading: countriesLoading} =
        useSelector((state) => state?.data) || [];
    const {identity, loading} = useSelector((state) => state?.settings) || [];
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllCountries());
        dispatch(getIdentityVerification());
    }, [dispatch]);
    const defaultValues = {
        ...identity?.[0],
        issuingDate: identity?.[0]?.issuingDate?.split("T")?.[0],
        expirationDate: identity?.[0]?.expirationDate?.split("T")?.[0],
    };

    const onSubmit = (data) => {
        // ENDPOINT NOT VERIFIED YET
        dispatch(submitIdentityVerification(data));
    };
    if (loading || countriesLoading) return <Loader />;

    return (
        <FormWrapper title={"identityVerification"}>
            <Form onSubmit={onSubmit} defaultValues={defaultValues}>
                <Input name="fullName" />

                <ReactSelect name="issuingCountry" options={countries || []} />
                <ReactSelect
                    name="IdType"
                    options={["personalId", "passport"]}
                />
                <Input name="idNumber" />
                <Input type="date" name="issuingDate" />
                <Input type="date" name="expirationDate" />

                <ImageUpload name="idImage" />
                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
}
